import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { getProfileApi } from '../../Api';
import ModalDadosDigital from './ModalDadosDigital'
import ModalDadosFisica from './ModalDadosFisica'
import ModalPix from './ModalPix';

const ProfileManager = () => {
    const navigate = useNavigate();
    const [profile, setProfile] = useState(null);
    const [loading, setLoading] = useState(true);
    const [activeStep, setActiveStep] = useState(null);

    // Função central para buscar os dados da API
    const fetchProfileData = async () => {
        try {
            setLoading(true);
            const response = await getProfileApi(); // Sua rota do backend
            const data = response.data;

            setProfile(data);

            // Lógica de decisão de qual modal abrir.
            // A ordem é importante — pendências de pagamento e cadastro têm
            // prioridade sobre o estado "tem/não tem carteirinha".
            if (data.pendencias.pagamento_aguardando) {
                setActiveStep('PAGAMENTO');
            } else if (data.pendencias.detalhes.digital_incompleta) {
                setActiveStep('DADOS_DIGITAL');
            } else if (data.pendencias.detalhes.impressao_incompleta) {
                setActiveStep('DADOS_FISICA');
            } else if (data.carteirinha?.proxima_acao === 'COMPRAR_NOVA') {
                // Sem pendência aberta E sem carteirinha válida -> manda
                // direto pra vitrine. Caso típico: Pix expirado, conta
                // existe mas nunca virou carteirinha.
                navigate('/produtos', { replace: true });
                return;
            } else {
                setActiveStep(null);
            }
        } catch (error) {
            console.error("Erro ao carregar perfil:", error);
        } finally {
            setLoading(false);
        }
    };

    // useEffect que dispara ao montar o componente
    useEffect(() => {
        fetchProfileData();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    // ProfileManager é puramente um "controlador" de modais de pendência —
    // sidebar já mostra nome/email do usuário, então não renderizamos H1 aqui.
    if (loading) return null;

    return (
        <>
            {activeStep === 'PAGAMENTO' && (
                <ModalPix
                    paymentId={profile.pendencias.pagamento_id}
                    onSuccess={fetchProfileData}
                />
            )}
            {activeStep === 'DADOS_DIGITAL' && (
                <ModalDadosDigital
                    carteirinhaId={profile.pendencias.detalhes.carteirinha_id}
                    reprovada={profile.pendencias.detalhes.digital_reprovada}
                    motivoReprovacao={profile.pendencias.detalhes.motivo_reprovacao}
                    dadosAtuais={profile.pendencias.detalhes.dados_atuais}
                    onSuccess={fetchProfileData}
                />
            )}
            {activeStep === 'DADOS_FISICA' && (
                <ModalDadosFisica
                    impressaoId={profile.pendencias.detalhes.impressao_id}
                    onSuccess={fetchProfileData}
                />
            )}
        </>
    );
};

export default ProfileManager;